import { render } from "./WithdrawalView.vue?vue&type=template&id=b25ff2b2&scoped=true"
import script from "./WithdrawalView.vue?vue&type=script&lang=js"
export * from "./WithdrawalView.vue?vue&type=script&lang=js"

import "./WithdrawalView.vue?vue&type=style&index=0&id=b25ff2b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b25ff2b2"]])

export default __exports__